<template>
  <header class="mobile-invite-header">
    <span>{{ title }}</span>
    <button ref="backButton" type="button" class="mobile-invite-back" :aria-label="$t('common.close')" @click="$emit('back')">
      <el-icon><Close /></el-icon>
    </button>
  </header>
</template>

<script>
import { Close } from '@element-plus/icons-vue'

export default {
  name: 'MobileInviteHeader',
  components: { Close },
  props: { title: { type: String, required: true } },
  emits: ['back'],
  methods: {
    focusBack() {
      this.$refs.backButton?.focus({ preventScroll: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-invite-header {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
  min-height: 56px;
  padding: 6px 8px 6px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--agst-border-color-lighter, #ebeef5);
  background: var(--agst-bg-color, #fff);
  color: var(--agst-text-color-primary, #303133);
  font-size: 18px;
  font-weight: 600;
  text-align: left;

  > span {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.mobile-invite-back {
  display: inline-flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 20px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--agst-color-primary, #2d66f0);
    outline-offset: -2px;
  }
}
</style>
